import getWindow from "./window";

export default function eventBusEmitter(eventName, value) {
  return getWindow().asos.eventBus.emit(eventName, value);
}
